import { createContext } from "react";
const initialValue = { trigger: 0, setTrigger: (num) => { } }
export const TriggerContext = createContext(initialValue)